import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
import { DeleteItemComponent } from '../delete-item/delete-item.component';
import { EditUserComponent } from '../dialog-modal/edit-user/edit-user.component';
import { HireRecruiterComponent } from '../dialog-modal/hire-recruiter/hire-recruiter.component';
import { OnboardingCompanyComponent } from '../onboarding-company/onboarding-company.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AddUserComponent } from '../dialog-modal/add-user/add-user.component';
import { Filter } from '../filter/filter.model';
import { PaginationInstance } from 'ngx-pagination';
import { AppService } from 'src/app/services/app/app.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { CommonService } from 'src/app/services/common/common.service';
import { ImportCsvComponent } from '../dialog-modal/import-csv/import-csv.component';
import { ViewCoursePreviewComponent } from '../courses/view-course-preview/view-course-preview.component';
import { FeatureService } from 'src/app/services/feature/feature.service';
import { ViewEmployeeComponent } from '../view-employee/view-employee.component';
import { AssignedEmployeeListComponent } from './assigned-employee-list/assigned-employee-list.component';
import { AssignCourseEmployeeWiseComponent } from '../courses/assign-course-employee-wise/assign-course-employee-wise.component';
import { ViewAssignedEmployeeComponent } from '../department/view-assigned-employee/view-assigned-employee.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { ViewCompanyComponent } from '../view-company/view-company.component';
import { ConfirmationModalComponent } from '../dialog-modal/confirmation-modal/confirmation-modal.component';
import { ContractService } from 'src/app/services/contract/contract.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { StarRatingComponent } from '../employees/star-rating/star-rating.component';
import { AddSingleUserComponent } from '../dialog-modal/add-single-user/add-single-user.component';
import { AssignUsersComponent } from './assign-users/assign-users.component';
// u_typ:1 then logged in user is recruiter company
// u_typ:0 then logged in user is company
@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent {
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public countPagination!: any
  public displayedColumns: string[] = ['first_name', 'phone_number', 'date_added', 'action'];
  public dataSource = new MatTableDataSource();
  public count!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  public displayedColumnsEmp: string[] = ['first_name', 'applied_time', 'signed_up', 'phone_number', 'status', 'action'];
  public dataSourceEmp = new MatTableDataSource();
  public countEmp!: any;
  @ViewChild(MatPaginator) paginatorEmp!: MatPaginator;

  public displayedColumnsRec: string[] = ['email', 'status', 'contract', 'action'];
  public dataSourceRec = new MatTableDataSource();
  public countRec!: any;
  @ViewChild(MatPaginator) paginatorRec!: MatPaginator;

  public displayedColumnsComp: string[] = ['email', 'time', 'status', 'contract', 'action'];
  public dataSourceComp = new MatTableDataSource();
  public countComp!: any;
  @ViewChild(MatPaginator) paginatorComp!: MatPaginator;

  public currentTab: string = "Manager";
  public imageURL: any = GlobalService.imageURL;
  private serverURL: any = GlobalService.serverURL;
  pageIndex = 0;
  pageSize = 15;
  public isFilterShow: boolean = false;
  public filterArr: any[] = [];
  public fieldCol: any[] = [
    { key_name: "First Name", key_val: "first_name", type: 'text' },
    { key_name: "Last Name", key_val: "last_name", type: 'text' },
    { key_name: "Email", key_val: "email", type: 'text' },
    { key_name: "Department", key_val: "d_i", type: 'select' },

  ];
  public operand: string = 'and'
  public filterObj: Filter = {
    arr: [],
    operand: this.operand
  }
  public filterShowObj = {
    managerFilter: false,
    empFilter: false,
  }
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public mainFilter = {
    manager: {
      arr: [],
      operand: this.operand,
      itemsPerPage: this.pageSizeOptions[0],
      currentPage: 0,
    },
    employee: {
      arr: [],
      operand: this.operand,
      itemsPerPage: this.pageSizeOptions[0],
      currentPage: 0,
    },
  }
  public searchInput: string = '';
  private previousInputValue: string = '';
  public selectedTab: number = 0
  public userInfo: any;
  public isContentCopied = false;
  public baseUrlDoc!: string;

  constructor(private _liveAnnouncer: LiveAnnouncer, public dialog: MatDialog, private userManagementService: UserManagementService, private router: Router,
    private spinner: NgxSpinnerService, private cd: ChangeDetectorRef, private appService: AppService, private permissionService: NgxPermissionsService,
    private commonService: CommonService, private featureService: FeatureService, private route: ActivatedRoute, private recruiterService: RecruiterService,
    private contractService: ContractService, private clipboard: Clipboard) { }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('sortEmp') sortEmp!: MatSort;
  @ViewChild('sortRec') sortRec!: MatSort;

  ngOnInit(): void {
    this.userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'))
    this.commonService.setTitle("User Management")

    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loadScripts()
    this.permissionService.loadPermissions(this.appService.getPermissionforUser());
    this.route.queryParams.subscribe((params) => {
      if (params && params['u'] && params['u'] == "emp") {
        this.selectedTab = 1
        this.currentTab = 'Employee'
        this.onTabChange(this.currentTab)
      }
      else {
        this.onPageChange(1)
      }
    })
  }
  ngAfterViewInit() { }
  loadScripts() {
    let node = document.createElement('script');
    node.src = "assets/js/custom-select.js";
    node.type = 'text/javascript';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  openDialog() {
    const dialogRef = this.dialog.open(StarRatingComponent, {
      width: '90%', maxWidth: "400px", height: "95%", maxHeight: '470px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onDeleteItem(api_type: string, usertype: any, id: any, element: any) {
    let email_id;
    if (id == null || id == '') {
      email_id = '&email=' + element["email"]
    }
    const dialogRef = this.dialog.open(DeleteItemComponent, {
      data: { api_type: api_type, usertype: usertype, id: id, email: email_id, block_type: element.active },
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["user_type"] == "manager") { this.managerList() }
        if (result["user_type"] == "employee") { this.empList() }
        if (result["user_type"] == "recruiter") { this.recruiterList() }
        if (result["user_type"] == "company") { this.companyList() }
      }
    });
  }
  onDownloadCert() {
    this.userManagementService.downloadCert({}).subscribe({
      next: (success: any) => {
        if (success.status == 200) {

        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  managerList = (): void => {
    this.spinner.show();
    let obj = {
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.mainFilter.manager.currentPage, this.mainFilter.manager.itemsPerPage),
      r_p: this.mainFilter.manager.itemsPerPage,
      f_a: this.mainFilter.manager['arr'],
      op_nd: this.mainFilter.manager['operand'],
    }
    this.userManagementService.managerList(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.spinner.hide()
          success.data.map((item: any) => item.first_name = this.capitalizeFirstLetter(item.first_name))
          this.dataSource = new MatTableDataSource(success.data)
          this.countPagination = this.count = success.count
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.previousInputValue = this.searchInput;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  empList = (): void => {
    this.dataSourceEmp.data = []
    this.spinner.show();
    let obj = {
      st: this.appService.startPageLogic(this.mainFilter.employee.currentPage, this.mainFilter.employee.itemsPerPage),
      r_p: this.mainFilter.employee.itemsPerPage,
      f_a: this.mainFilter.employee['arr'],
      op_nd: this.mainFilter.employee['operand'],
      sh: this.searchInput.trim(),
      pl_id: '',
    }
    this.userManagementService.empListNew(obj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.spinner.hide()
          success.data.employee_list.map((item: any) => item.first_name = this.capitalizeFirstLetter(item.first_name))
          this.dataSourceEmp = new MatTableDataSource(success.data.employee_list)
          this.countPagination = this.countEmp = success.count
          this.dataSourceEmp.sort = this.sortEmp;
          this.dataSourceEmp.paginator = this.paginatorEmp;
          this.previousInputValue = this.searchInput;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  capitalizeFirstLetter(text: string) {

    if (text != '' || text != null) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    else {
      return text;
    }
  }
  recruiterList = (): void => {
    this.spinner.show();
    let obj = {
      start: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      pageSize: this.config.itemsPerPage,
      filter_arr: [],
      search: ""
    }
    this.recruiterService.list(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide()
        this.dataSourceRec = new MatTableDataSource(success.data)
        this.baseUrlDoc = success.base;
        this.countPagination = this.countRec = success.count
        this.dataSourceRec.sort = this.sortRec;
        this.dataSourceRec.paginator = this.paginatorRec;
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  companyList = (): void => {
    this.spinner.show();
    let obj = {
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      f_a: [],
      sh: this.searchInput.trim(),
      r_p: this.config.itemsPerPage,
      op_nd: this.mainFilter.manager['operand'],
    }
    this.recruiterService.getCompanyList(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide()
        this.baseUrlDoc = success.base;
        this.dataSourceComp = new MatTableDataSource(success.data)
        this.countPagination = this.countRec = success.count
        this.dataSourceRec.sort = this.sortRec;
        this.dataSourceRec.paginator = this.paginatorRec;
        this.previousInputValue = this.searchInput
      },
      error: (error: any) => {
        this.previousInputValue = this.searchInput
        this.dataSourceComp.data = [];
        this.commonService.handleError(error);
      },
    });
  }
  onTabChange(value: any) {
    // whenever tab changes reset the filter and its value to blank
    this.searchInput = ''
    this.filterObj.arr = []
    this.config.currentPage = 1;
    this.config.itemsPerPage = this.pageSizeOptions[0]
    if (value && value["tab"] && value["tab"]["textLabel"]) {
      this.currentTab = value["tab"]["textLabel"]
    }
    if (this.currentTab == 'Employee') {
      this.fieldCol.push({ key_name: "Signed Up Date", key_val: "created_on", type: 'date' },)
      this.countPagination = this.countEmp
      this.config.itemsPerPage = this.mainFilter.employee.itemsPerPage
      this.config.currentPage = this.mainFilter.employee.currentPage
      if (this.dataSourceEmp.data.length == 0) {
        // this.empList()
        this.onPageChange(1)
      }
    }
    if (this.currentTab == 'Recruiter') {
      this.countPagination = this.countRec
      if (this.dataSourceRec.data.length == 0) {
        this.recruiterList()
      }
    }
    if (this.currentTab == 'Manager') {
      this.fieldCol.pop()
      this.config.itemsPerPage = this.mainFilter.manager.itemsPerPage
      this.config.currentPage = this.mainFilter.manager.currentPage
      this.countPagination = this.count
      if (this.dataSource.data.length == 0) {
        this.managerList()
      }
    }
    if (this.currentTab == 'Company') {
      if (this.dataSourceComp.data.length == 0) {
        this.companyList()
      }
    }
  }
  getFilterArr() {
    if (this.currentTab == 'Employee') { }
    else {

    }
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.callAPI()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.callAPI()
  }
  callAPI() {
    if (this.currentTab == 'Manager') {
      this.mainFilter.manager.currentPage = this.config.currentPage
      this.mainFilter.manager.itemsPerPage = this.config.itemsPerPage
      this.managerList()

    }
    if (this.currentTab == 'Recruiter') {
      this.recruiterList()
    }
    if (this.currentTab == 'Company') {
      this.companyList()
    }
    if (this.currentTab == 'Employee') {
      this.mainFilter.employee.currentPage = this.config.currentPage
      this.mainFilter.employee.itemsPerPage = this.config.itemsPerPage
      this.empList()
    }
  }
  onHireRecruiter() {
    const dialogRef = this.dialog.open(HireRecruiterComponent, {
      width: '500px', height: '96%', maxHeight: "500px",
      enterAnimationDuration: '500ms', exitAnimationDuration: "300ms",
      panelClass: "hireRecruiter-modal"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.recruiterList()
      }
    });
  }
  onEditItem(usertype: String, value: any) {
    let eheight: any;
    let eMaxheight: any;
    if (usertype == 'Manager') {
      eheight = '98%',
        eMaxheight = '730px'
    }
    else {
      eheight = '90%',
        eMaxheight = '650px'
    }
    const dialogRef = this.dialog.open(EditUserComponent, {
      data: { data: value, user_type: usertype },
      width: '80%', minWidth: '300px', height: eheight, maxWidth: '796px', maxHeight: eMaxheight,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result["user_type"] == "manager") {
        this.managerList()
      }
      if (result["user_type"] == "employee") {
        this.empList()
      }
    });
  }
  onExportCSV(userType: string) {
    this.spinner.show()
    let data: {} = {
      "user": userType
    }
    this.userManagementService.exportCSV(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.appService.downloadFile(success.msg, 'sample_csv')
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onImportCSV(userType) {
    const dialogRef = this.dialog.open(ImportCsvComponent, {
      width: '80%',
      minWidth: '300px',
      height: '98%',
      maxHeight: '690px', maxWidth: '800px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: { userType: userType },
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (userType == "manager") {
        this.managerList()
      }
      if (userType == "employee") {
        this.empList()
      }
    });
  }
  onDownloadSample(usertype) {
    let url = 'https://univate.s3.eu-west-1.amazonaws.com/api/' + usertype + '.csv'
    this.appService.downloadFile(url, 'sample_csv')
  }
  onAddNewUser(userType: String) {
    const dialogRef = this.dialog.open(AddUserComponent, {
      width: '90%',
      height: '90%',
      maxWidth: '1200px',
      maxHeight: '729px',
      // panelClass: 'onboard-modal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: { userType: userType }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.callAPI()
      }
    });
  }

  onAssign(userType: any) {
    const dialogRef = this.dialog.open(AssignUsersComponent, Object.assign({
      data: userType, width: '50%', minWidth: '310px', height: '98%', maxHeight: '500px', maxWidth: '700px', autoFocus: false,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire"
    }));
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onAddSingleUser() {
    const dialogRef = this.dialog.open(AddSingleUserComponent, {
      width: '90%',
      height: '100%',
      maxWidth: '700px',
      maxHeight: '850px',
      // panelClass: 'onboard-modal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      // data: { userType: userType }
    });
    dialogRef.afterClosed().subscribe(result => {

      this.managerList()

    });
  }
  onFilterView() {
    if (this.currentTab == 'Employee') {
      this.filterShowObj.empFilter = !this.filterShowObj.empFilter
    }
    if (this.currentTab == 'Manager') {
      this.filterShowObj.managerFilter = !this.filterShowObj.managerFilter
    }
    // this.isFilterShow = !this.isFilterShow;
    // if (this.isFilterShow == true) { this.filterArr = [{ filter_value: '', contains: '', containsArr: [''] }] }
  }
  doFilter = (event: any) => {
    let newVal = event.target?.value
    if (this.currentTab == 'Manager') {
      this.dataSource.filter = newVal.trim().toLocaleLowerCase();
    }
    if (this.currentTab == 'Employee') {
      this.dataSourceEmp.filter = newVal.trim().toLocaleLowerCase();
    }
    if (this.currentTab == 'Recruiter') {
      this.dataSourceRec.filter = newVal.trim().toLocaleLowerCase();
    }
  }
  callApi(obj) {
    this.filterObj = obj
    if (this.currentTab == "Manager") {
      this.mainFilter.manager = obj
    }
    else {
      this.mainFilter.employee = obj
    }
    this.config.currentPage = 1
    this.callAPI()
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage = 1
      this.callAPI()
    }
  }
  onGo() {
    if (this.searchInput.trim() != '') {
      this.config.currentPage = 1
      this.callAPI()
    }
  }
  openPreview() {
    const dialogRef = this.dialog.open(ViewCoursePreviewComponent, {
      width: '96%',
      height: '94%',
      maxHeight: "800px",
      maxWidth: '100vw',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  getFeatureList() {
    let obj = {}
    this.featureService.getFeatureList(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onViewEmployee(id) {
    let data = {
      employee_id: id,
      type: 'company'
    }
    const dialogRef = this.dialog.open(ViewEmployeeComponent, {
      width: '95%',
      height: '95vh',
      maxWidth: '95vw',
      panelClass: 'onboard-modal',
      data: data,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onAssignCourse() {
    const dialogRef = this.dialog.open(AssignCourseEmployeeWiseComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire", autoFocus: false,
      height: '100%',
      width: '90%',
      maxHeight: '746px',
      maxWidth: '1182px'
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  onViewManager(element) {
    const dialogRef = this.dialog.open(ViewAssignedEmployeeComponent, Object.assign({
      data: { id: element.manager_id, type: "view_employee" },
      height: '100%',
      width: '95%',
      maxHeight: '746px',
      maxWidth: '1382px',
      minWidth: '300px'
    }));
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  formatTimestamp(timestamp: number): string {
    const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  onViewCompany(element: any, type: any) {
    let data = {
      co_i: element.co_i,
      type: 'company',
      userData: element,
      mType: type,
    }
    const dialogRef = this.dialog.open(ViewCompanyComponent, {
      width: '95%',
      height: '95%',
      maxWidth: '95vw',
      panelClass: 'onboard-modal',
      data: data,
      disableClose: true,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  acceptReject(type, val, element) {
    let dataObj = {
      ap_id: element.id,
      app: val
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { content_type: 'accept_reject', data_type: type, dataObj: dataObj, item_type: "company_accept" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.companyList()
      }

    });
  }
  onUploadContract() {
    this.spinner.show()
    this.contractService.recAddContract({}).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          // this.isSpinnerLoading=false
          this.spinner.hide();
          var newWindow = window.open(success.data.url, '_blank', 'height=700,width=700');

        }
      },
      error: (error: any) => {
        this.spinner.hide();
        // this.isSpinnerLoading=false
        this.commonService.handleError(error);
      },
    });
  }
  onDownload(element) {
    this.appService.downloadFile(this.baseUrlDoc + element, 'contract_doc')
  }
  onSignContract(id) {
    this.spinner.show()
    this.recruiterService.companySignDoc(id).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.spinner.hide();
          var newWindow = window.open(success.data.url, '_blank', 'height=700,width=700');
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }
  onShareSignUpLink() {
    this.recruiterService.shareSignUpLink({}).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          // this.isSpinnerLoading=false
          this.spinner.hide();
          this.clipboard.copy(success.msg)
          this.isContentCopied = true;
          setTimeout(() => {
            this.isContentCopied = false;
          }, 1000);
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }

  onViewAssignedEmployee(id) {
      let data = {
        ma_i: id,
        type: 'manager'
      }
      const dialogRef = this.dialog.open(AssignedEmployeeListComponent, {
        width: '95%',
        height: '95%',
        maxWidth: '95vw',
        panelClass: 'onboard-modal',
        data: data,
        enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
      });
  
      dialogRef.afterClosed().subscribe(result => {
      });
    }
}